export const AREA_VIEWBOX = "0 0 322 229.4";
export const AREA_LAYOUT = [
  {
    name: "1",
    path: "M125.2,4.6h12.1V15.5H125.2Z",
    textTransform: "translate(113.21 7.87)",
    fill: "#FF5555",
  },
  {
    name: "2",
    path: "M139,4.6h12.1V15.5H139Z",
    textTransform: "translate(126.98 7.87)",
    fill: "#FF5555",
  },
  {
    name: "3",
    path: "M158.5,4.6h12.1V15.5H158.5Z",
    textTransform: "translate(146.42 7.75)",
    fill: "#FF5555",
  },
  {
    name: "4",
    path: "M172.4,4.6h12.1V15.5H172.4Z",
    textTransform: "translate(160.36 7.75)",
    fill: "#FF5555",
  },
  {
    name: "5",
    path: "M186.3,4.6h12.1V15.5H186.3Z",
    textTransform: "translate(174.31 7.75)",
    fill: "#FF5555",
  },
  {
    name: "6",
    path: "M205.2,4.6h12.1V15.5H205.2V4.6Z",
    textTransform: "translate(193.14 7.75)",
    fill: "#FF5555",
  },
  {
    name: "7",
    path: "M219.1,4.6h12.1V15.5H219.1Z",
    textTransform: "translate(207.08 7.75)",
    fill: "#FF5555",
  },
  {
    name: "8",
    path: "M158.3,38.1h12.1V49H158.3Z",
    textTransform: "translate(146.26 40.77)",
    fill: "#FF5555",
  },
  {
    name: "9",
    path: "M172,38.2h12V49.1H172Z",
    textTransform: "translate(159.96 40.81)",
    fill: "#FF5555",
  },
  {
    name: "10",
    path: "M185.7,38.2h12.1V49.1H185.7Z",
    textTransform: "translate(172.3 40.81)",
    fill: "#FF5555",
  },
  {
    name: "11",
    path: "M65.3,152.2H38.7V188H65.3Z",
    textTransform: "translate(32.76 167.3)",
  },
  {
    name: "12",
    path: "M65.3,126.7l-26.6-1.8v21H65.3Z",
    textTransform: "translate(32.57 132.62)",
  },
  {
    name: "13",
    path: "M55.5,121.8l3.2-12.6L43.3,105,39,118.6Z",
    textTransform: "translate(29.42 111.56)",
  },
  {
    name: "14",
    path: "M72.3,95.8,66,93.7l2.1-8.1L52,75.2l-7.7,25.9,24.5,7.4Z",
    textTransform: "translate(36.52 91.01)",
  },
  {
    name: "15",
    path: "M61.8,61.2l-4.6,3.2-3.9,9.1L72.6,86.1l4.9-3.5Z",
    textTransform: "translate(42.7 70.8)",
  },
  {
    name: "16",
    path: "M73.3,53l-8.5,6.4L76.7,75.2l8.5-6.4Z",
    textTransform: "translate(55.5 61.32)",
  },
  {
    name: "17",
    path:
      "M88.8,26.5,90.6,29l-7.7,5.6L75.2,43l1.4,2.1-2.5,1.8L92.3,71.8h2.5l9.5-7V31.9l4.2-3.2V18.9l-2.1-2.5h-3.2Z",
    textTransform: "translate(71.8 41.2)",
  },
  {
    name: "18",
    path:
      "M124.2,11.8H111.9V37h1.8V47.9h-1.8V60.2h1.8v2.1h15.4V52.8h7.7V57h15.8V17H124.2Z",
    textTransform: "translate(112.79 34.2)",
  },
  {
    name: "19",
    path: "M199.5,17.2H157.1V37.3h42.4Z",
    textTransform: "translate(158.85 24.47)",
    fill: "#FFDD55",
  },
  {
    name: "20",
    path:
      "M244.6,11.8H232.3V17H204V57h15.8V52.8h7.7v9.5h15.4V60.2h1.8V47.9h-1.8V37h1.8V11.8Z",
    textTransform: "translate(204.91 34.2)",
  },
  {
    name: "21",
    path:
      "M250.2,16.3l-2.1,2.5v9.8l4.2,3.2V64.7l9.5,7h2.5l18.2-24.9L280,45l1.4-2.1-7.7-8.4L266,28.9l1.8-2.5L253.4,16.2h-3.2Z",
    textTransform: "translate(245.91 41.2)",
  },
  {
    name: "22",
    path: "M291.8,59.4,283.3,53,271.4,68.8l8.5,6.4Z",
    textTransform: "translate(262.21 61.32)",
  },
  {
    name: "23",
    path: "M299.3,64.3l-4.6-3.2L279,82.5l4.9,3.5,19.3-12.6Z",
    textTransform: "translate(272.29 70.8)",
  },
  {
    name: "24",
    path: "M290.6,93.7l-6.3,2.1,3.5,12.6,24.5-7.4-7.7-25.9L288.5,85.6Z",
    textTransform: "translate(278.47 89.01)",
  },
  {
    name: "25",
    path: "M317.5,118.6l-4.2-13.7-15.4,4.2,3.2,12.6Z",
    textTransform: "translate(288.31 111.56)",
  },
  {
    name: "26",
    path: "M317.9,145.9v-21l-26.6,1.8V146h26.6Z",
    textTransform: "translate(285.16 132.62)",
  },
  {
    name: "27",
    path: "M317.9,188V152.3H291.3V188Z",
    textTransform: "translate(285.16 167.3)",
  },
  {
    name: "28",
    path: "M198.1,57V49.6H158.5V57h15.8V52.1h8.1V57Z",
    textTransform: "translate(145.26 51.29)",
    fill: "#FFDD55",
  },
  {
    name: "29",
    path: "M89.8,188V162H70.9v26Z",
    textTransform: "translate(60.95 172.2)",
    fill: "#FFDD55",
  },
  {
    name: "30",
    path: "M89.8,157.1V138.2H70.9v18.9Z",
    textTransform: "translate(60.95 144.88)",
    fill: "#FF5555",
  },
  {
    name: "31",
    path: "M89.8,134.7V109.1H70.9v25.6Z",
    textTransform: "translate(60.95 119.14)",
    fill: "#FFDD55",
  },
  {
    name: "32",
    path: "M96.1,95.8,85.2,81.1,74.7,88.8l5.3,7,7.7,6.3Z",
    textTransform: "translate(64.66 88.84)",
    fill: "#FFDD55",
  },
  {
    name: "33",
    path: "M99.6,94.1l3.5-2.8V68.9L88.4,79Z",
    textTransform: "translate(77.36 78.68)",
    fill: "#FFDD55",
  },
  {
    name: "34",
    path: "M131.2,66.1H109.1v42.4h22.1Z",
    textTransform: "translate(100.7 84.46)",
    fill: "#FFDD55",
  },
  {
    name: "35",
    path: "M178.3,69.9H163.4l-2.1-7H134v45.5h44.3Z",
    textTransform: "translate(136.69 82.88)",
    fill: "#FFDD55",
  },
  {
    name: "36",
    path: "M223,108.4V62.9H195.7l-2.1,7H178.7v38.5Z",
    textTransform: "translate(181.46 82.88)",
    fill: "#FFDD55",
  },
  {
    name: "37",
    path: "M247.4,66.1H225.3v42.4h22.1Z",
    textTransform: "translate(216.99 84.46)",
    fill: "#FFDD55",
  },
  {
    name: "38",
    path: "M253.4,91.3l3.5,2.8L268.1,79,253.4,68.8Z",
    textTransform: "translate(240.34 78.68)",
    fill: "#FFDD55",
  },
  {
    name: "39",
    path: "M271.3,81.1,260.4,95.8l8.4,6.3,7.7-6.3,5.3-7Z",
    textTransform: "translate(250.51 88.84)",
    fill: "#FFDD55",
  },
  {
    name: "40",
    path: "M285.7,134.7V109.1H266.8v25.6Z",
    textTransform: "translate(256.77 119.14)",
    fill: "#FFDD55",
  },
  {
    name: "41",
    path: "M266.7,138.2v18.9h18.9V138.2Z",
    textTransform: "translate(256.77 144.88)",
    fill: "#FF5555",
  },
  {
    name: "42",
    path: "M285.7,162H266.8v26h18.9Z",
    textTransform: "translate(256.77 172.12)",
    fill: "#FFDD55",
  },
  {
    name: "43",
    path: "M248.2,193.3h32.2V214H248.2Z",
    textTransform: "translate(244.87 200.86)",
  },
  {
    name: "44",
    path: "M178.6,193.3h63.7V214H178.6V193.3Z",
    textTransform: "translate(191.06 200.86)",
    fill: "#FFDD55",
  },
  {
    name: "45",
    path: "M113.6,193.3h63.7V214H113.6Z",
    textTransform: "translate(126.03 200.86)",
    fill: "#FFDD55",
  },
  {
    name: "46",
    path: "M78.7,193.3h32.2V214H78.7Z",
    textTransform: "translate(75.38 200.86)",
  },
  {
    name: "47",
    path: "M214,218.4h32.2V233H214Z",
    textTransform: "translate(210.63 222.9)",
  },
  {
    name: "48",
    path: "M179.4,218.4h32.2V233H179.4V218.4Z",
    textTransform: "translate(176.1 222.9)",
    fill: "#FFDD55",
  },
  {
    name: "49",
    path: "M145.5,218.4h32.2V233H145.5Z",
    textTransform: "translate(142.14 222.9)",
    fill: "#FFDD55",
  },
  {
    name: "50",
    path: "M111.2,218.4h32.2V233H111.2Z",
    textTransform: "translate(107.9 222.9)",
  },
  {
    name: "A",
    path:
      "M34.1,82.2l-5.6-2.5-1.8,4.8c-1.4,3.9-2.7,7.8-3.9,11.6-3.7,12.1-5.6,21.1-5.6,27.1v83.7h6.3V123.5c0-6.3,1.8-15,5.3-26.3,1.1-3.5,2.3-7.1,3.6-10.7Z",
    textTransform: "translate(2.26 135.82)",
  },
  {
    name: "B",
    path:
      "M42.7,82.5,37.1,80l-1.8,4.8c-1.4,3.9-2.7,7.8-3.9,11.6-3.7,12.1-5.6,21.1-5.6,27.1v73.9h6.3V123.8c0-6.3,1.8-15,5.3-26.3,1.1-3.5,2.3-7.1,3.6-10.7Z",
    textTransform: "translate(10.63 135.82)",
  },
  {
    name: "C",
    path:
      "M332.7,96.1c-1.2-3.8-2.5-7.6-3.9-11.6L327,79.7l-5.6,2.5,1.6,4.3c1.3,3.6,2.5,7.2,3.6,10.7,3.5,11.3,5.3,20,5.3,26.3v83.4h6.3V123.2C338.3,117.2,336.5,108.2,332.7,96.1Z",
    textTransform: "translate(317.14 135.82)",
  },
  {
    name: "D",
    path:
      "M318.3,80.1l-5.6,2.5,1.6,4.3c1.3,3.6,2.5,7.2,3.6,10.7,3.5,11.3,5.3,20,5.3,26.3v73.6h6.3V123.6c0-6-1.9-15-5.6-27.1-1.2-3.8-2.5-7.6-3.9-11.6Z",
    textTransform: "translate(307.99 135.82)",
  },
  {
    name: "Floor",
    path: "M196.6,111.3h67.2v75.4H196.6V111.3Z",
    textTransform: "translate(207.89 146.25)",
    fill: "#FF7F2A",
  },
  {
    name: "Floor",
    path: "M95.3,111.9h67.2v75.4H95.3Z",
    textTransform: "translate(106.59 146.82)",
    fill: "#FF7F2A",
  },
  {
    name: "STAGE",
    path: "M164.5,111.6h30.1V187H164.5Z",
    textTransform: "translate(154.96 145.98)",
    fill: "black",
    color: "white",
    selectable: false,
  },
];
